export default "__VITE_ASSET__j$4KwFyn__"